import useGetEventByType from "src/lib/hooks/useGetEventByType";

export default function EventCounter({
  type,
  count,
}: {
  type: string;
  count: number;
}) {
  const eventType = useGetEventByType(type);

  return (
    <div className="flex items-center gap-1 w-fit">
      <img
        src={
          eventType?.icon
            ? `/event-icons/${eventType?.icon}`
            : "/event-icons/neutral.svg"
        }
        alt={`Obrázek ${eventType.name}`}
        className="h-4 w-4 object-contain"
      />
      <span>{count}</span>
    </div>
  );
}
